import React from 'react';
import { routeTitle } from './navConfig';

// ============================================================================
// CHA-240 — Carbon shell TopBar (chrome only)
// CHA-272 — live AZURE SYNC chip (view model from useSyncStatus, wired in
// InMoceanDashboard; this component stays purely presentational)
// ============================================================================
const formatStamp = (now = new Date()) => {
  const day = now.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
  const mon = now.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
  const time = now.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return `${day} ${mon} ${now.getDate()} · ${time}`;
};

export default function TopBar({ currentRoute, sync, navLabelOverrides }) {
  const title = routeTitle(currentRoute, navLabelOverrides);
  return (
    <div className="bg-carbon-white border-b border-carbon-border px-8 py-3.5 flex items-center justify-between sticky top-0 z-[5]">
      <div className="flex items-baseline gap-3">
        <h1 className="font-plex text-xl font-semibold m-0 tracking-[-0.01em] text-carbon-ink">
          {title}
        </h1>
        <span className="font-plex-mono text-[11px] text-carbon-gray-50">{formatStamp()}</span>
      </div>
      <div className="flex items-center gap-1.5 font-plex-mono text-[10.5px] text-carbon-gray-70 bg-carbon-gray-10 border border-carbon-border px-3 py-1">
        <span
          className={`w-1.5 h-1.5 rounded-full animate-pulse ${
            !sync ? 'bg-carbon-gray-40' : sync.ok ? 'bg-carbon-green-50' : 'bg-carbon-orange-40'
          }`}
        />
        {sync ? sync.label : 'AZURE SYNC —'}
      </div>
    </div>
  );
}
